import { DriveService } from './drive';
export function drive(options) {
    return new DriveService(options);
}
